import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import { ApiHandlerDiscreteParameter, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import cloneDeep from "lodash/cloneDeep";

interface PlaceOrderParameter {
    isPending?: boolean;
    poNumber: string;
    vatNumber?: string;
    notes?: string | "";
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

export const SetCartStatusExtensions: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;
    const { cartId } = state.pages.onePageCheckout;
    const notes = state.pages.checkoutShipping.editedCartNotes || "";
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const newStatus = cart?.requiresApproval
        ? "AwaitingApproval"
        : props.parameter?.isPending
            ? "PendingPaymentValidation"
            : "Submitted";
    props.cartToUpdate = {
        ...cloneDeep(cart),
        status: newStatus,
        poNumber: props.parameter.poNumber,
        customerVatNumber: props.parameter.vatNumber || "",
        notes,
        properties: { "deliveryWarehouse": state?.cpeState.warehouseData.selectedWarehouseForInventory || "" }
    };
};

replaceInChain(chain, SetCartStatus, SetCartStatusExtensions);
